<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/platform-user/table">分配用户资源列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">分配用户资源</span>
      <userResourceLimitForm :userid="currentUserid"
                             :callbackAfterUpdate="afterUpdateUserResource"
                             :key="currentUserid">
      </userResourceLimitForm>
    </layout-panel>
  </div>
</template>

<script>
import userResourceLimitForm from '@views/platform-user-province/components/userResourceLimitForm.vue'

export default {
  components: {userResourceLimitForm},
  data () {
    return {
      currentUserid: this.$route.params.userid
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    afterUpdateUserResource () {
      this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
        this.$router.replace({name: '后台用户管理'})
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-user-province/pages/platformUserProvinceForm.vue